import React from 'react'
import Section1 from '../SECTION1/Section1';
import Section2 from '../SECTION2/Section2';
import Section3 from '../SECTION3/Section3';
import Section4 from '../SECTION4/Section4';
import Section5 from '../SECTION5/Section5';
import Section6 from '../SECTION6/Section6';
import Section7 from '../SECTION7/Section7';
import Section8 from '../SECTION8/Section8';
import Section9 from '../SECTION9/Section9';
import Section10 from '../Section10/Section10';
import Footer from '../FOOTER/Footer';


const Home = () => {
    return (
        <>
            <Section1 />
            <Section2 />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
            <Section7 />
            <Section8 />
            <Section9 />
            <Section10 />
            <Footer/>
        </>
    )
}

export default Home
